<template>
  <div ref="carousel">
    <slot
      :changeSlide="changeSlide"
      :activeSlide="activeSlide"
    />
  </div>
</template>

<script>
import Glide from '@glidejs/glide';

export default {
  data() {
    return {
      glide: undefined,
      activeSlide: 0,
    }
  },
  mounted() {
    setTimeout(this.renderGlide(), 500);
  },
  methods: {
    renderGlide() {
      const carousel = this.$refs.carousel.querySelector("[data-glide-window]");

      if (carousel) {
        this.glide = new Glide(carousel, {
          type: 'carousel',
          gap: 0,
          animationDuration: 600,
          autoplay: 6000,
          perView: 1,
        }).mount();

        this.glide.on("run", () => {
          this.activeSlide = this.glide.index;
        });
      }
    },
    changeSlide(s) {
      if (s == 'next') {
        s = '>';
      } else if (s == 'prev') {
        s = '<';
      } else {
        s = `=${s}`;
      }

      this.glide.go(s);
    },
  }
}
</script>